import { NotificationMessages } from "common/types";

export function useMailboxItemNotificationMessages() {
  const replaceAsync: NotificationMessages["replaceAsync"] = (key, JSONmessage, callback) => {
    // TODO: implement
    console.log(key, JSONmessage, callback);
  };

  return {
    replaceAsync,
  };
}
